var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7375 9.06824C14.3958 9.41914 13.9833 9.59459 13.5 9.59459C13.2833 9.59459 13.0792 9.55608 12.8875 9.47905C12.6958 9.40203 12.5167 9.29504 12.35 9.15811C11.9 9.43198 11.525 9.78288 11.225 10.2108C10.925 10.6387 10.7667 11.118 10.75 11.6486H24L23 18.8378H18.65V17.2973H21.775C21.875 16.6126 21.9708 15.9279 22.0625 15.2432C22.1542 14.5586 22.25 13.8739 22.35 13.1892H7.65C7.75 13.8739 7.84583 14.5586 7.9375 15.2432C8.02917 15.9279 8.125 16.6126 8.225 17.2973H11.35V18.8378H7L6 11.6486H9.25C9.26667 10.8099 9.50417 10.0482 9.9625 9.36351C10.4208 8.67883 11.0167 8.13964 11.75 7.74595C11.7667 7.24955 11.9417 6.83446 12.275 6.50068C12.6083 6.16689 13.0167 6 13.5 6C13.9833 6 14.3958 6.17545 14.7375 6.52635C15.0792 6.87725 15.25 7.3009 15.25 7.7973C15.25 8.29369 15.0792 8.71734 14.7375 9.06824ZM12.35 23.4595H17.65L18.35 16.2703H11.65L12.35 23.4595ZM11 25L10.175 16.4243C10.1417 15.9793 10.275 15.5856 10.575 15.2432C10.875 14.9009 11.2417 14.7297 11.675 14.7297H18.325C18.7583 14.7297 19.125 14.9009 19.425 15.2432C19.725 15.5856 19.8583 15.9793 19.825 16.4243L19 25H11Z",
    fill: "var(--fill-0, #4DBEF8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentIcon);
export default __webpack_public_path__ + "static/media/present-icon.4f9a79addd70409b189f83fccde8bd31.svg";
export { ForwardRef as ReactComponent };